// extracted by mini-css-extract-plugin
module.exports = {"modal":"ProductOptionModal-module__modal___1YYTx","image":"ProductOptionModal-module__image___3j53g","price":"ProductOptionModal-module__price___xHMWi"};